import React from 'react'
import {Flex} from '/app/src/component'
import { connect } from 'react-redux'
import TutorialItem from './TutorialItem'
import TutorialContainer from './TutorialContainer'
import TutorialModel from '/app/src/model/Tutorial/model';

class Tutorial extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cardColor: 'white'
        }
        this._setCardColor = this._setCardColor.bind(this);
        this._renderContainer = this._renderContainer.bind(this);
        this.__renderItems = this.__renderItems.bind(this);

    }

    componentDidMount(){
        this.props.dispatch(TutorialModel.read());
    }


    _setCardColor(){

        if(this.state.cardColor === '#f7f7f7'){
            this.setState({
                cardColor: 'white'
            })
        }else{
            this.setState({
                cardColor: '#f7f7f7'
            })
        }

    }

    _renderContainer(tutorialItems){
        const container = tutorialItems.map((tutorialItem, index) => {
        const text = tutorialItem.get('container');
        const containerItems = tutorialItem.get('items');

            return(
                <TutorialContainer key={index} id={index} text={text}>
                {this.__renderItems(containerItems, index)}
                </TutorialContainer>
            );
        })

        return container;
    }

    __renderItems(containerItems, listId){


        const items = containerItems.map((containerItem, index) => {
            const header = containerItem.get('header');
            const description = containerItem.get('text');
            const done = containerItem.get('done');
            const id = containerItem.get('id');

            return(
                <TutorialItem key={index} id={id} listId={listId} header={header} description={description} done={done} name='user'/>
            )
        })

        return items.toJS();
    }

    render(){
        return(
            <Flex column grow overflowY='auto' padding='50px'>
                {this._renderContainer(this.props.tutorialItems)}
            </Flex>
        )
        /*
        return(
            <Flex column grow overflowY='auto' padding='50px'>
            <TutorialContainer text='Kom igång med Jibber!'>
                <TutorialItem header='Välj färg på chatten' description='Försök hitta en färg som passa din hemsida!' done={true} name='customization'/>
                <TutorialItem header='Skapa ett automeddelande' description='Skräddasy ert egna automeddelande' done={false}/>
                <TutorialItem header='Swisha till Tuan' description='Glöm inte att betala till Tuan!' done={false}/>
            </TutorialContainer>
            <TutorialContainer text='Andra saker'>
                <TutorialItem header='Lägg till medarbetare' description='Lägg till dina medarbetare!' done={true}/>
                <TutorialItem header='Skapa snabbmeddelanden!' description='Använd snabbmeddelanden för att snabbt svara kunder' done={true}/>
                <TutorialItem header='Lägg till en profilbild' description='Visa vem du är för omvärlden!' done={true}/>
            </TutorialContainer>
            <TutorialContainer text='Andys order'>
                <TutorialItem header='Ta bort collapsable' description='Gör ju för fan ingen nytta' done={true}/>
                <TutorialItem header='Ta bort sträck' description='Ser ju för fan inget' done={false}/>
                <TutorialItem header='Gör en modal' description='Är emot joyride lol' done={false}/>
            </TutorialContainer>
            </Flex>
        );
        */
    }
}

function mapStateToProps(state, ownProps)
{
    let tutorialItems = state.getIn(['tutorial', 'items']);
    return {
        tutorialItems: tutorialItems
    };
}

export default connect(mapStateToProps)(Tutorial);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Tutorial/index.js